import React from "react";
import styled from "styled-components";
import MarkChatRead from "icons/MarkChatRead";

const GreenCircle = styled.div`
  background-color: #4caf5033;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #4caf50;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4caf5066;
    cursor: pointer;
  }
`;

interface Props {
  onClick?: () => void;
  disabled?: boolean;
}

export const DocumentChatReadyButton = ({onClick, disabled}: Props) => (
  <GreenCircle
    onClick={disabled ? undefined : onClick}
    style={disabled ? {filter: "grayscale(1)", cursor: "default"} : undefined}
  >
    <MarkChatRead style={{width: "0.9em", height: "0.9em", marginTop: "1px"}} />
  </GreenCircle>
);
